import { createContext } from '@lit/context';
import { UserProfile } from '../datatypes/user-profile';

export const UserProfileContext = createContext<UserProfile | undefined>(
  'user-profile'
);
